import React, { useState } from 'react';
import classNames from 'classnames';

interface SwitchProps {
  checked: boolean;
  disabled?: boolean;
  onChange?: (val: boolean) => void | Promise<void>;
  loading?: boolean;
  className?: string
}

const prefixCls = 'wm-switch';

const Switch: React.FC<SwitchProps> = ({ checked, disabled, onChange, loading = false , className}) => {
  const [internalLoading, setInternalLoading] = useState(false);

  const handleClick = async () => {
    if (disabled || internalLoading || loading) return;

    const next = !checked;
    const result = onChange?.(next);

    if (result instanceof Promise) {
      setInternalLoading(true);
      try {
        await result;
      } finally {
        setInternalLoading(false);
      }
    }
  };

  const isLoading = loading || internalLoading;

  return (
    <div
      className={classNames(prefixCls, className,{
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-loading`]: isLoading,
      })}
      onClick={handleClick}
    >
      <div className={classNames(
        `${prefixCls}-checkBox`,
        {
          [`${prefixCls}-checked`]: checked,
        }
      )}>
        <div className={`${prefixCls}-dot`} />
      </div>
     
    </div>
  );
};

export default Switch;
